import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { environment } from '../../environments/environment';

/** Mirrors typical `ApiResponse<string>` from the job files API. */
export interface JobAttachmentsApiResponse {
  status: boolean;
  responseCode: number;
  message: string;
  data: string | null;
  details?: unknown[];
  unixTime?: number;
  traceId?: string;
}

/** POST form body = JobFileUploads; VendorKey on query `?VendorKey=`. */
@Injectable({ providedIn: 'root' })
export class JobAttachmentsService {
  private readonly http = inject(HttpClient);

  saveAttachments(formData: FormData, vendorKey: string): Observable<JobAttachmentsApiResponse> {
    const base = environment.apiBaseUrl.replace(/\/$/, '');
    const path = `${base}/api/job/upload-from-landing-page`;
    const qs = new URLSearchParams({ VendorKey: vendorKey.trim() });
    const url = `${path}?${qs.toString()}`;
    return this.http.post<JobAttachmentsApiResponse>(url, formData);
  }
}
